import type { SVGProps } from 'react';
const SvgAngleDown = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M11.2928 15.1884L7.21157 11.1071C6.92948 10.825 6.92948 10.3689 7.21157 10.0898L7.88978 9.41158C8.17187 9.12949 8.62801 9.12949 8.9071 9.41158L11.8 12.3045L14.6929 9.41158C14.975 9.12949 15.4311 9.12949 15.7102 9.41158L16.3884 10.0898C16.6705 10.3719 16.6705 10.828 16.3884 11.1071L12.3072 15.1884C12.0311 15.4705 11.5749 15.4705 11.2928 15.1884V15.1884Z" />
  </svg>
);
export default SvgAngleDown;
